import React from 'react';
import { PopupType } from 'src/AppState/PopupsStackState';
import { DialogGeneric } from './dialog/DialogGeneric';
import { observer } from 'mobx-react-lite';

export type PopupTemplatePropsType = {
    popup: PopupType;
};
export const PopupStackTemplate = observer(({ popup }: PopupTemplatePropsType): JSX.Element => {
    switch (popup.template) {
        case 'generic':
            return (
                <DialogGeneric
                    title={popup.title}
                    message={popup.message}
                    onConfirm={popup.onConfirm}
                    onCancel={popup.onCancel}
                    onDelete={popup.onDelete}
                    hasOverlay={popup.hasOverlay}
                    confirm_label={popup.confirm_label}
                    cancel_label={popup.cancel_label}
                    delete_label={popup.delete_label}
                    isLoading={popup.isLoading}
                    dialogClassName={popup.dialogClassName}
                    titleClassName={popup.titleClassName}
                />
            );
    }
});
